export default "__VITE_ASSET__DJ1qn7YC__"